import React from 'react';
import { Link } from 'react-router-dom';
//import M from 'materialize-css';

import './css/styles.css';


class Dropdown extends React.Component {

    container_drop = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            url_banner_inicio: '',
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    componentWillMount(){
        fetch('/api/uip/imagenes/banner', {
            method: 'GET',
            headers: {
                'Content-type': 'application-json'
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    url_banner_inicio: response[0].url,
                })
            })
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    handleButtonClick = () => {
        this.setState(state => {
            return {
                open: !state.open,
            };
        });
    };

    handleClickOutside = event => {
        if (this.container_drop.current && !this.container_drop.current.contains(event.target)) {
          this.setState({
            open: false,
          });
        }
      };

    render() {
        return (
            <div className="App">
                <div className="container_drop" ref={this.container_drop}>
                    <button type="button-drop" className="button-drop" onClick={this.handleButtonClick}>
                        <i class="material-icons">menu</i>
                    </button>
                    {this.state.open && (
                        <div className="dropdown">
                            <ul className="dropdown-ul">
                                <Link to="/inicio"><li className="dropdown-li">Inicio</li></Link>
                                <Link to="/especiales"><li className="dropdown-li">Especiales</li></Link>
                                <Link to="/publicaciones"><li className="dropdown-li">Publicaciones</li></Link>
                                <Link to="/launidad"><li className="dropdown-li">La Unidad</li></Link>
                                <Link to="/noshizofeliz"><li className="dropdown-li">Nos hizo feliz</li></Link>
                                <a href={this.state.url_banner_inicio} 
                                   target="__blank">
                                    <li className="dropdown-li">Sin Reclutamiento</li>
                                </a>
                                
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Dropdown;